const saveSearch = (apiUrl, values) => fetch(`${apiUrl}saved-searches/`,
    {
        method: "POST",
        credentials: "same-origin",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            name: values.name,
            emailAlerts: (values.emailAlerts || false).toString() === 'true',
            searchContext: values.searchContext
        })
    })
    .then((response) => response.json());

export default saveSearch;